import { LocationEntity } from "@src/core/entities";
import { trackError } from "@src/core/sentry";
import { getGeocode } from "use-places-autocomplete";

export const getLocationFromMap = async (e: google.maps.MapMouseEvent): Promise<LocationEntity | undefined> => {
  const lat = e?.latLng?.lat();
  const lng = e?.latLng?.lng();

  if (!lat || !lng) return;

  try {
    const payload = { location: { lat, lng } };
    const addressList = await getGeocode(payload);
    const [{ formatted_address }] = addressList;

    return {
      latitude: lat,
      longitude: lng,
      address: formatted_address,
    };
  } catch (error: unknown) {
    trackError(error instanceof Error ? error : new Error(String(error)), {
      code: 'FE_0007',
      extra: { lat, lng },
    });
    return undefined;
  }
};